
import { WarningProps,SplitLayout,Warning,Updater } from "@npd-ng/adp-component-library";
import {useSelector } from 'react-redux';
import { useState } from 'react';
import { IADPState } from 'shared/typings/AppStateTypes';
import { LoadingProps } from 'shared/typings/ViewTypes';
import { Box } from "@enaep-ng/benchmark";

export const ErrorLoadingView = () => {
  const [wait, setWait] = useState(false);
  const state = useSelector(
    (state: { rootState: IADPState }) => state.rootState
  );
  const content = useSelector(
    (state: { rootState: IADPState }) => state.rootState.currentLanguageContent
  );
  const actionsContent = content?.actions;

  const onTryAgain =()=>{
      window.location.reload();
  }
  
    const warningMsg = {
      "code": "Error code: 000",
      "title": content?.FailedToLoad.title ? content.FailedToLoad.title : "Failed to load the application",
      "message": content?.FailedToLoad.message ? content.FailedToLoad.message :"An error has been encountered and the application has stopped working.<br/>Please try again. If problems persist, please contact the NAEP Help Desk."
    }
  
    const warningProps: WarningProps = {
        errorCode: "",
        title: warningMsg.title,
        message: warningMsg.message,
        buttons:[{
          label: actionsContent?.tryAgain || "Try Again",
          action:onTryAgain,
          variant: "primary"
      },{
            label: actionsContent?.exit || "Exit NAEP",
            action:()=>{window.close()},
            variant: "secondary"
        }, ]
  }
  const loadingViewProps: LoadingProps = {
    title: "Loading",
    message: "",
    subTitle: "Please Wait",
    spinnerAlt:state.currentLanguageContent?.imageAltText.verifyingIcon as string
  }
  
  return (
    <>
    {wait ? (
    <SplitLayout logoAlt={state.currentLanguageContent?.imageAltText.naepLogo as string}>
      <Updater {...loadingViewProps} type="wait" />
    </SplitLayout>) 
    :
    (
      <SplitLayout logoAlt={state.currentLanguageContent?.imageAltText.naepLogo as string} alignment='left'>
      <Box className="fixedHeight" />
      <Box sx={{
          padding:"calc(22px * var(--zoom))", 
          textAlign: 'left'
        }}>
        <Warning {...warningProps}/>
      </Box>
    </SplitLayout>
    )}
    </>
  )
}
